import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import styles from './styles/index.module.scss';

const Button = ({
  tag: Tag,
  color,
  type,
  className,
  children,
  onClick,
  ...restProps
}) => {
  const buttonClassName = cn(
    {
      [styles.buttonPrimary]: color === 'primary',
      [styles.buttonSecondary]: color === 'secondary',
      [styles.buttonTransparent]: color === 'transparent',
      [styles.buttonIcon]: type === 'icon',
      [styles.buttonBlock]: type === 'block',
    },
    styles.button,
    className,
  );

  return (
    <Tag
      {...restProps}
      className={buttonClassName}
      type={Tag === 'button' ? 'button' : undefined}
      onClick={onClick}
    >
      {children}
    </Tag>
  );
};

Button.propTypes = {
  type: PropTypes.oneOf(['icon', 'block']),
  color: PropTypes.oneOf(['primary', 'secondary', 'transparent']),
  tag: PropTypes.string,
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  children: PropTypes.node,
  onClick: PropTypes.func,
};

Button.defaultProps = {
  type: null,
  color: null,
  tag: 'button',
  className: null,
  children: null,
  onClick: () => {},
};

Button.displayName = 'Button';

export default Button;
